import { trackerStatsSlice } from './slice';

export const { setDateRange, selectSource, setCurrentPage, setPageLimit } = trackerStatsSlice.actions;
